module.exports = __webpack_public_path__ + "media/images/logo-white-b130d11808d7f51b79ea35ced755e49a.svg";